


export const DISTANCE_COMPLETE:number = 300; // 1er niveau ??
export const FREQUENCE_EVT:number = 3;
export const NB_CYCLE_JOURNEE:number = 20; // attention par un chiffre impair

 // ------------- carcs de personnage
export const VITESSE_DE_BASE:number = 5; // 5 ou un peu plus